import { EABFilterImplementationType, SQDCActionStatus, type FilterOption } from "@/graphql";
import type { ActionFilter } from "../FilterTypes";
import StatusFilterUI from "../ui/StatusFilterUI.vue";
import StatusFilterBadge from "../ui/badges/StatusFilterBadge.vue";

export default class StatusFilter implements ActionFilter {
  constructor(
    public readonly status: SQDCActionStatus[],
    public readonly isNegated?: boolean,
  ) {}

  static readonly Badge = StatusFilterBadge;

  static readonly UI = StatusFilterUI;

  getActionFilter(): FilterOption | undefined {
    return {
      filter: {
        type: EABFilterImplementationType.ACTION_STATUS,
        value: {
          value: this.status,
          negated: this.isNegated ?? false,
        },
      },
    };
  }
}
